import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PermissionComponent } from '../shared/components/permission/permission.component';
import { AuthGuard } from '../shared/guards/auth.guard';
import { HomeComponent } from './home/home.component';


const routes: Routes =
  [
    { path: '', component: HomeComponent },
    { path: 'permission', component: PermissionComponent },
    { path: 'um', loadChildren: () => import('./users/users.module').then(m => m.UsersModule), canActivate: [AuthGuard], },
    { path: 'grs', loadChildren: () => import('./garage/garage.module').then(m => m.GarageModule) }
  ];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule { }
